import React, { useEffect, useState } from "react";
import { Box, IconButton } from "@mui/material";
import { Delete } from "@mui/icons-material";
import TransitionsModal from "../components/Modal";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { Icon } from "@iconify/react";
import { deleteApi, getApi } from "../config/configAxios";
import CustomLoader from "../components/CustomLoader";
import AdminLayout from "../layouts/adminLayout/AdminLayout";
import {formatDate} from "../utils/date";

const Appointment = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openStore, setOpenStore] = useState(false);
  const [see, setSee] = useState({});

  const fetchData = async () => {
    try {
      const res = await getApi(`appointment-appointment`);
      setData(res.data.data);
    } catch (err) {
      toast.error(err?.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleView = async (id) => {
    setOpenStore(true);
    try {
      const res = await getApi(`appointment/${id}`);
      setSee(res.data.data);
    } catch (err) {
      toast.error(err?.message);
    }
  };
  console.log(see);
  // delete
  const handleDelete = async (id) => {
    Swal.fire({
      title: "Confirm delete",
      text: "Are you sure you want to delete this?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          try {
            await deleteApi(`appointment/${id}`)
              .then((res) => {
                toast.success("Data deleted successfully!");
              })
              .catch((err) => {
                toast.error("An error occurred while updating status");
              })
              .finally(() => {
                fetchData();
              });
          } catch (err) {
            toast.error(err?.response?.data?.error || "update failed");
          }
        } catch (error) {
          Swal.fire(
            "Error",
            "An error occurred while delete the user.",
            "error"
          );
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelled", "The user was not deleted.", "info");
      }
    });
  };

  return (
    <AdminLayout title={"Appointment"}>
      {loading ? (
        <CustomLoader />
      ) : (
        <div>
          <div className="flex justify-between p-3">
            <h1 className="text-gray-700 font-medium">Appointment list</h1>
            <div></div>
          </div>
          <div className="table-wrap">
            <table className="table-main shadow-md">
              <thead className="table-h">
                <tr>
                  <th className="table-h">SN</th>
                  <th className="table-h">Name</th>
                  <th className="table-h">Subject</th>
                  <th className="table-h">Number</th>
                  <th className="table-h">Date</th>
                  <th className="table-h">Action</th>
                </tr>
              </thead>
              <tbody className="table-b">
                {data.map((item, index) => (
                  <tr key={item.id}>
                    <td className="table-b">{index + 1}</td>

                    <td className="table-b">{item.name}</td>
                    <td className="table-b">{item.subject}</td>
                    <td className="table-b">{item.number}</td>
                    <td className="table-b">{item.date}</td>
                    <td className="table-b">
                      <Box display="flex">
                        <IconButton
                          className="mr-3"
                          onClick={() => handleDelete(item.id)}
                        >
                          <Delete className="text-red-500" />
                        </IconButton>
                        <IconButton
                          className="mr-3"
                          onClick={() => handleView(item.id)}
                        >
                          <Icon icon="ph:eye" className="text-blue-500" />
                        </IconButton>
                      </Box>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* modal  */}

      <TransitionsModal
        title={"Message"}
        open={openStore}
        setOpen={setOpenStore}
      >
        <div className="grid md:grid-cols-2 grid-cols-1 gap-2">
          <div className="md:col-span-2">
            <p>
              <span className="font-bold">Name: </span> {see?.name}
            </p>
            <p>
              <span className="font-bold">Subject: </span> {see?.subject}
            </p>
            <p>
              <span className="font-bold">District: </span> {see?.district}
            </p>
            <p>
              <span className="font-bold">Number: </span> {see?.number}
            </p>
            <p>
              <span className="font-bold">Date: </span> {see?.date}
            </p>
            <p>
              <span className="font-bold">Message: </span> {see?.message}
            </p>
          </div>
        </div>
      </TransitionsModal>
    </AdminLayout>
  );
};

export default Appointment;
